// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1N9ZS","content":"styles_content__3UMF_","checkbox":"styles_checkbox__2XDh9","checkboxLabel":"styles_checkboxLabel__2ZXuA"};